<template>
<div>
    <Header />
    <div class="desktop">
        <BlackHeaderCenter :headerText="headerText" :subText="subText" :fadedText="fadedText" />
    </div>
    <div class="mobile">
        <BlackHeaderMobile :headerText="headerText" :subText="subText" :fadedText="fadedText" :isTextinput="false" />
    </div>
    <BodyLinks />
    <b-container class=" mt-4">
        <Activation />
       
        <div class="form-container">
            <form action="" @submit.prevent="updateClub">
                <p class="font18bold">Club Details</p>
                 <p class="font18bold">Update club language  :
                    <select class="" v-model="clubData.language_id">
                        <option value="" selected disabled>Please select nationality</option>
                        <option v-for="(lang, index) in languages" :key="index" :value="lang.language_id">
                            {{ lang.name }}
                        </option>
                    </select> </p>
                <div class="row">
                    <b-form-group class="col-md-6 mb-4" label-for="moderator_name">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon icon="person"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="text" required v-model="clubData.moderator_name" placeholder="Moderator Name"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="club_name">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon icon="tag"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="text" required v-model="clubData.club_name" placeholder="Club Name"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="attendance_mode">
                        <b-form-select v-model="clubData.attendance_mode" required :options="attendances"></b-form-select>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="duration">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon icon="clock"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="text" v-model="clubData.duration" placeholder="Duration e.g 1 day"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="address" v-if="clubData.attendance_mode == 'online'">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon icon="geo"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="text" v-model="clubData.address" placeholder="Online Link"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="address" v-if="clubData.attendance_mode == 'physical'">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon icon="globe"></b-icon>
                            </b-input-group-prepend>
                            <vue-google-autocomplete v-model="clubData.address" id="cl-map" ref="address" classname="form-control" placeholder="Enter an address or location" v-on:placechanged="getAddressData">
                            </vue-google-autocomplete>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="discussion_topic">
                        <b-input-group class="">
                            <b-input-group-prepend is-text>
                                <b-icon icon="tag"></b-icon>
                            </b-input-group-prepend>
                            <b-form-input type="text" v-model="clubData.discussion_topic" placeholder="Topic of Discussion"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group class="col-md-6 mt-2 mb-4" label-for="input-1">
                        <textarea style="height:auto !important" v-model="clubData.club_description" required :rows="clubData.attendance_mode ==='online' || clubData.attendance_mode ==='physical'? 3: 2" placeholder="Club Description" class="form-control"></textarea>
                    </b-form-group>

                    <b-form-group class="col-md-6 mb-4" label-for="fee_status">
                        <b-form-select v-model="clubData.fee_status" required :options="fees"></b-form-select>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="currency" v-if="clubData.fee_status ==='Paid'">
                        <b-form-select v-model="clubData.currency" :options="currencies"></b-form-select>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="amount" v-if="clubData.fee_status ==='Paid'">
                        <b-input-group class="">
                            <b-form-input type="number" min="0" step=".01" v-model="clubData.amount" placeholder="Price Per member"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="start_day">
                        <date-picker required v-model="clubData.start_day" valueType="format" format="YYYY-MM-DD" placeholder="Start Date"
                            id="start_Day" type="date"></date-picker>
                    </b-form-group>
                    
                    <b-form-group class="col-md-6 mb-4" label-for="end_day">
                        <date-picker required v-model="clubData.end_day" valueType="format" format="YYYY-MM-DD" placeholder="End Date"
                            id="endDay" type="date"></date-picker>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="input-1">
                        <b-form-timepicker no-flip v-model="clubData.start_time" now-button reset-button locale="en"></b-form-timepicker>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="input-1">
                        <b-form-timepicker no-flip v-model="clubData.end_time" now-button reset-button locale="en"></b-form-timepicker>
                    </b-form-group>
                </div>
                <b-row>
                    <b-form-group class="col-md-12 mt-4 mb-4" label-for="input-1">
                        <div class="file-container mb-4">
                            <p>Upload Club Avatar</p>
                            <div @click="openFile" class="btn btn-warning">Choose File
                                <b-icon scale="0.8" icon="cloud-arrow-up"></b-icon>
                            </div>
                            <b-form-file @change="showFileName" style="visibility:hidden" id="clubAvatar" class="mt-3" plain></b-form-file><span>{{filename}}</span>
                        </div>
                    </b-form-group>
                </b-row>
                <p class="font18bold">Member Preference</p>
                <b-row class="mt-4">
                    <b-form-group class="col-md-6 mb-4" label-for="age_limit">
                        <b-input-group class="">
                            <b-form-input type="number" min="1" v-model="clubData.age_limit" placeholder="Age Limit (not under)"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="member_limit">
                        <b-input-group class="">
                            <b-form-input type="number" min="0" v-model="clubData.member_limit" placeholder="Member Limit (No. of total members)"></b-form-input>
                        </b-input-group>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="member_gender">
                        <b-form-select required v-model="clubData.member_gender" :options="genders"></b-form-select>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="member_category">
                        <b-form-select v-model="clubData.member_category" :options="statuses"></b-form-select>
                    </b-form-group>
                    <b-form-group class="col-md-6 mb-4" label-for="member_nationality_id">
                        <select class="mb-3 custom-select" v-model="clubData.member_nationality_id">
                            <option value="" selected disabled>Please select nationality</option>
                            <option v-for="(country, index) in countries" :key="index" :value="country.country_id">
                                {{ country.name }}
                            </option>
                        </select>
                    </b-form-group>
                </b-row>
                <b-row class="mt-4">
                    <b-form-group class=" col-md-12 mb-4" label-for="input-1">
                        <button class="float-right btn btn-warning">{{btnText}}
                            <font-awesome-icon :icon="['fas', 'arrow-right']" /> </button>
                    </b-form-group>
                </b-row>
            </form>
            <div class="text-center" v-if="showPaymentBtn">
                <button @click="completePayment" class="btn btn-secondary">Complete Payment Process</button>
            </div>

        </div>
    </b-container>
    <Footer />
</div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import BodyLinks from "@/components/BodyLinks.vue";
import Footer from "@/components/Footer.vue";
import BlackHeaderCenter from "@/components/BlackHeaderCenter.vue";
import BlackHeaderMobile from "@/components/BlackHeaderMobile.vue";
import Activation from "@/components/Activation.vue";
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import axios from "axios";
import {
    getBaseUrl
} from "../../../../utils/common";
const base_url = getBaseUrl();
export default {
    name: 'update-language-club',
    components: {
        Header,
        BodyLinks,
        BlackHeaderCenter,
        BlackHeaderMobile,
        Activation,
        VueGoogleAutocomplete,
        Footer
    },
    data: function () {
        return {
            headerText: "create Language club",
            subText: "Connect with people round the globe by creating a language club.",
            fadedText: "Language",
            searchInput: {
                name: '',
                flag: ''
            },
            btnText: 'Update Club',
            stripe_url: '',
            clubData: {
                moderator_name: '',
                attendance_mode: null,
                duration: '',
                fee_status: null,
                club_description: '',
                currency: null,
                amount: '',
                discussion_topic: '',
                member_gender: null,
                age_limit: '',
                member_limit: '',
                address: '',
                member_nationality_id: null,
                member_category: null,
                start_day: '',
                end_day: '',
                start_time: '',
                end_time: '',
                club_name: '',
            },
            filename: '',
            showPaymentBtn: false,
            attendances: [{
                    value: null,
                    text: 'Select Attendance mode'
                },
                {
                    value: "physical",
                    text: 'In Person'
                },
                {
                    value: "online",
                    text: 'Online'
                },
            ],
            fees: [{

                    value: null,
                    text: 'Fee status'
                }, {

                    value: "Free",
                    text: "Free"
                },
                {
                    value: 'Paid',
                    text: "Paid"
                },

            ],
            currencies: [{

                value: null,
                text: 'Select Currency'
            }, {

                value: "USD",
                text: "USD"
            }, ],
            genders: [{
                    value: null,
                    text: 'Select member gender'
                },
                {
                    value: 'male',
                    text: 'Male'
                },
                {
                    value: 'female',
                    text: 'Female'
                },
                {
                    value: 'other',
                    text: 'Other'
                },
                {
                    value: 'any',
                    text: 'Any'
                },

            ],
            statuses: [{
                    value: null,
                    text: 'Select member status'
                },
                {
                    value: 'family',
                    text: 'Family'
                },
                {
                    value: 'couple',
                    text: 'Couple'
                },
                {
                    value: 'singles',
                    text: 'Singles'
                },
                {
                    value: 'any',
                    text: 'Any'
                },

            ],
            showLanguageDetails: false,
            showSearchLanguage: true,
            iscountryAdded: false,
            islanguageAdded: false,
            disabled: true,
            disableBtn: true,
            showDropdown: false,
            showBtn: true,
            languages: [],
            countryAdded: [],
            countries: []
        }
    },
    mounted() {
        this.getClubDetails();
        this.getCountries();
        this.getLanguages();
    },
    methods: {
        openFile() {
            document.getElementById('clubAvatar').click()
        },
        showFileName() {
            const file = document.getElementById('clubAvatar').files[0];
            this.filename = file.name
        },
        getAddressData: function (_addressData, placeResultData) {
            if (placeResultData.formatted_address !== null) {
                this.clubData.address = placeResultData.formatted_address;
            }
        },
        async getLanguages() {
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/languages`,
                    method: "GET",
                })
                this.languages = resp.data.data;
                this.showDropdown = true
            } catch (error) {
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        async getCountries() {
            try {
                const resp = await axios.get(`${base_url}/api/v2/countries`)
                const country = {
                    country_id: null,
                    name: "Any",
                    namecode: "Any",
                    phonecode: "A"
                };
                const countries = [{
                    ...country
                }, ...resp.data.data];
                this.countries = countries;
            } catch (error) {
                console.warn(error);
            }
        },
        async getClubDetails() {
            const id = this.$route.params.id;
            try {
                const resp = await axios({
                    url: `${base_url}/api/v2/languageclubs/${id}`,
                    method: "GET",
                })
                this.clubData = Object.assign({}, resp.data.data);
            } catch (error) {
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        async updateClub() {
            this.btnText = 'Updating Club...'
            const image = document.getElementById("clubAvatar").files[0]
            let data = new FormData();
            if (image) {
                data.append("images", document.getElementById("clubAvatar").files[0]);
            }
            data.append('language_id', this.clubData.language_id)
            data.append('club_name', this.clubData.club_name)
            data.append('duration', this.clubData.duration)
            data.append('attendance_mode', this.clubData.attendance_mode)
            data.append('club_description', this.clubData.club_description)
            data.append('address', this.clubData.address)
            data.append('moderator_name', this.clubData.moderator_name)
            data.append('discussion_topic', this.clubData.discussion_topic)
            data.append('member_gender', this.clubData.member_gender)
            data.append('age_limit', this.clubData.age_limit)
            data.append('member_limit', this.clubData.member_limit)
            data.append('member_nationality_id', this.clubData.member_nationality_id)
            data.append('member_category', this.clubData.member_category)
            data.append('fee_status', this.clubData.fee_status)
            if (this.clubData.currency) {
                data.append('currency', this.clubData.currency)
            }
            if (this.clubData.amount) {
                data.append('amount', this.clubData.amount)
            }
            data.append('start_day', this.clubData.start_day)
            data.append('end_day', this.clubData.end_day)
            data.append('start_time', this.clubData.start_time)
            data.append('end_time', this.clubData.end_time)
            try {
                const clubId = this.clubData.club_id;
                const resp = await axios({
                    url: `${base_url}/api/v2/languageclubs/${clubId}?_method=PUT`,
                    data: data,
                    method: "POST",
                })
                this.btnText = 'Update Club';
                if (resp.data.stripe_onboard_url === null) {
                    this.$router.push("/languages/clubs/created");
                } else {
                    this.showPaymentBtn = true;
                    this.stripe_url = resp.data.stripe_onboard_url
                    this.$root.$refs.A.makeToast('warning', resp.data.message)
                }
            } catch (error) {
                if (error.response.status == "403") {
                    this.showPaymentBtn = true;
                    this.stripe_url = error.response.data.stripe_onboard_url
                }
                this.btnText = 'Update Club';
                this.$root.$refs.A.makeToast('danger', error.response.data.message)
            }
        },
        completePayment() {
            window.open(this.stripe_url, "_blank")
        }
    }
}
</script>

<style scoped>
.row {
    margin-left: 0 !important;
}

.bordered {
    border-left: 2px solid #ccc;
}

.time-frame {
    background: rgba(247, 177, 49, 0.15);
    border-radius: 16px;
    padding: 2px 13px;
    text-transform: uppercase;
    margin-top: 10px
}

.btn-grey {
    background: #565C63 !important;
    border-radius: 4px !important;
    color: #fff !important
}

.light-input-container {
    border: 1px solid rgba(86, 92, 99, 0.54);
    padding: 10px;
    border-radius: 5px;
    background: #fff;
}

.custom-select {
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
    border-radius: 8px;
    padding: 20px 16px;
    border: none;
    height: 59px;
}

.custom-input-group {
    box-shadow: none !important;
    margin: 0 !important
}

.custom-input-group .input-group-prepend {
    padding-top: 18px !important;
}

.btn-culture {
    padding: 10px 60px !important;
}

.form-control {
    height: calc(2em + 0.75rem + 15px) !important;

}

.input-group {
    margin: 0
}

.form-control:focus {
    outline: none !important;
    box-shadow: none !important;
}

.custom-select:focus {
    outline: none !important;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.custom-select:focus {
    outline: none !important;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
}

.bi-search {
    margin-right: 1rem;
}

.custom-select .caret {
    padding-right: 10px;
}

.custom-control {
    height: calc(1.5em + 0.75rem + 15px) !important;

}

.btn-box {
    margin: 14px 0
}

.head-box {
    margin: 35px auto auto;
    box-shadow: 0px 4px 20px rgb(0 0 0 / 10%);
    border-radius: 5px;
    background-color: #F6F7F7;
}

.inner-header-box {
    padding: 20px;
    border-radius: 4px;
    cursor: pointer;
}

.font18bold {
    font-size: 18px;
    font-weight: 500;
}

.font24bold {
    font-size: 24px;
    font-weight: 500;
}

.custom-notify {
    border-radius: 8px;
    box-shadow: 0px 4px 14px rgb(0 0 0 / 10%);
    transition: all 0.5s ease-in-out !important;
}

.country-list-span {
    background: #000;
    color: #fff;
    padding: 15px 30px;
    border-radius: 8px;
    margin-right: 25px;
}

.autocomplete-list {
    top: 62px !important;
    text-align: left !important;
    width: 100% !important
}

.autocomplete-list ul li {
    border: none !important;
    transition: all 0.1s ease-in-out !important;
}

.autocomplete-list ul li:hover {
    background: #F6F7F7;
}

.country-list-span span:nth-child(2) {
    cursor: pointer
}

.autocomplete-list img,
.country-list-span img {
    width: 20px;
    height: 20px;
    border-radius: 50%;
}
</style>
